<template>
    <div class="home-page">
        <Header></Header>
        <!-- 面包屑导航 -->
        <div class="breadcrumbs">
          <div class="breadcrumbs-content m_section_inner disflex">
            <div class="bd-ul">
              <ul class="">
                <li class="home"><a href="./">{{$t('home')}}</a></li>
                <li><span>{{$t('katakana')}}</span></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="page_title">
          <div class="m_section_inner" style="background: linear-gradient(rgba(255,255,255,0), rgba(255,255,255,0)), url(../../static/images/Hiragana-Title-Pic.png) no-repeat 0 0 / cover ">
            <div class="disflex sub-content">
              <div class="disflex topic-header">
                <div class="topic-titles">
                  <div class="jp fw7">ひらがな</div>
                  <div class="jp">{{$t('katakana')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
		<div class="">
      <div class="content crfff por">
        <div class="kanji-content mt30">
          <div class="disflex" style="justify-content: right;margin-right: 30px;width: auto;">
            <div class="Practice text-shadow mt20" @click="getToAnswer()">{{$t('Practice')}}<img src="../../static/images/up.png"></div>
          </div>
          <div class="grammar-detail">
            <div class="" :id="'Topic'+(index+1)" v-for="(item,index) in list">
              <div class="kanji-ul">
                <ul style="justify-content: space-between;">
                  <li v-for="(item1,index1) in item" class="ac" style="border: none;margin:10px 10px;">
                    <em class="yin cr8a570f">{{item1.yin}}</em>
                    <div class="" @click="getToDetail(item1)" style="border: 2px solid #2c3e5e;padding:15px;">
                      <img width="80" :src="item1.word_image"/>
                    </div>
                    <button
                      @click="toggleVocabularyAudio(item1, index, index1)"
                      :class="{ 'image-grow': activeAudioIndex === `${index}-${index1}` }"
                    >
                      <img style="width: 36px;" src="../../static/images/yin2.png" alt="Play audio">
                    </button>
                    <audio
                      preload="auto"
                      :ref="`audioVocabulary${index}-${index1}`"
                      @ended="onAudioEnded(index, index1)"
                    >
                      <source :src="item1.word_audio" type="audio/mp3">
                    </audio>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
		</div>

      <Dialog ref="levelDialog" type="alert" title="Reminder" width="80" :modalFoot="false">
        <div class="invited-c ac" slot="mdBox" style="">
          <div class="invited-l">
            <h2 class="ac mt30 font-family " style="color: #2a2d5a;font-size: 50px"> {{$t('Grammar_tips')}}</h2>
          </div>
          <div class="sure_btn" @click="closeBuyPopup">
            <button class=" btn6 font-family mt20" style="line-height: 103px;color: #fff;font-size: 30px;" >{{$t('OK')}}</button>
          </div>
        </div>
      </Dialog>

	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        list:[],
        typeList:[],
        type:'',
        info:{},
        activeAudioIndex: null
      }
    },
	created(){
    this.getList();
	},
    mounted() {
      // 在组件挂载后检查URL hash并滚动到对应位置
      this.$nextTick(() => {
        this.scrollToHash();
      });
    },
    watch: {
      // 监听路由变化，当hash变化时滚动到对应位置
      '$route'(to, from) {
        if (to.hash !== from.hash) {
          this.$nextTick(() => {
            this.scrollToHash();
          });
        }
      },
      // 监听list数据加载完成
      'list'() {
        // 数据加载完成后滚动到hash位置
        this.$nextTick(() => {
          this.scrollToHash();
        });
      }
    },
    methods: {
      // 生成唯一的音频索引
      getAudioIndex(topicIndex, itemIndex) {
        return `${topicIndex}-${itemIndex}`;
      },
      // 切换词汇音频播放/暂停
      toggleVocabularyAudio(item, topicIndex, itemIndex) {
        const audioIndex = this.getAudioIndex(topicIndex, itemIndex);
        const audioRef = `audioVocabulary${audioIndex}`;

        // 获取音频元素 - 注意：在v-for中$refs返回的是数组
        let audioElement = null;
        if (this.$refs[audioRef]) {
          // 在v-for中，$refs返回数组，取第一个元素
          audioElement = Array.isArray(this.$refs[audioRef])
            ? this.$refs[audioRef][0]
            : this.$refs[audioRef];
        }

        if (audioElement) {
          if (this.activeAudioIndex === audioIndex) {
            // 如果点击的是当前正在播放的音频，则暂停
            audioElement.pause();
            this.activeAudioIndex = null;
          } else {
            // 暂停其他音频
            this.pauseAllAudios();
            // 播放当前音频
            this.activeAudioIndex = audioIndex;
            audioElement.currentTime = 0;
            audioElement.play().catch(e => {
              console.log("播放失败:", e);
              this.activeAudioIndex = null;
            });
          }
        } else {
          console.log("音频元素未找到:", audioRef);
        }
      },
      pauseAllAudios() {
        // 遍历所有音频引用并暂停
        Object.keys(this.$refs).forEach(ref => {
          if (ref.startsWith('audioVocabulary')) {
            let audioElements = this.$refs[ref];
            if (Array.isArray(audioElements)) {
              audioElements.forEach(audio => {
                if (audio && audio.pause) {
                  audio.pause();
                  audio.currentTime = 0;
                }
              });
            } else if (audioElements && audioElements.pause) {
              audioElements.pause();
              audioElements.currentTime = 0;
            }
          }
        });
        this.activeAudioIndex = null;
      },
      // 音频播放结束
      onAudioEnded(topicIndex, itemIndex) {
        const audioIndex = this.getAudioIndex(topicIndex, itemIndex);
        if (this.activeAudioIndex === audioIndex) {
          this.activeAudioIndex = null;
        }
      },
      getToAnswer(type){
        this.$router.push({path:'/KatakanaLearn',query: {}});
      },
      getToDetail(item){
        this.$router.push({path:'/KatakanaResult',query: {id:item.id}});
      },
      getList(){
        let that = this
        that.$parent.loadModal(true);
        that.$api.post('/api/katakana/list',null,r =>{
          that.$parent.returnCode(r,function(){
            that.list = r.data
            that.$parent.loadModal(false);
          })
        })
      },
      closeBuyPopup(){
        this.$refs.levelDialog.closeMask();
        this.$router.push({path:'/',query: {}});
      },
      statusText(status) {
        switch (status) {
          case 1: return this.$t('no_start')
          case 2: return this.$t('in_process')
          case 3: return this.$t('finished')
          default: return ''
        }
      },
      // 滚动到hash对应的元素
      scrollToHash() {
        if (this.$route.hash) {
          const hash = this.$route.hash.slice(1); // 去掉#号
          const element = document.getElementById(hash);
          if (element) {
            // 计算元素位置并添加140px偏移
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - 150;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }
      }
	}
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/Katakana.vue